// extracted by mini-css-extract-plugin
export var currencyInput = "_n4-1";
export var currencySymbol = "_n4-0";